<script lang="ts">
	import { Container, Icon, Text } from '@Shelly/shelly-design-system';
	import EmInfoTooltip from './EmInfoTooltip.svelte';

	export let widgetClass = '';
	export let title = '';
	export let subtitle = '';
	export let infoText = '';
	export let titleIcon = '';
	export let titleIconSecondary = '';

	$: containerClass = ['energy-widget', widgetClass].filter(Boolean).join(' ');
</script>

<Container class={containerClass} type="glass" noScroll fullHeight>
	{#if title || subtitle || infoText || $$slots.actions}
		<div class="energy-widget-heading">
			<div class="energy-widget-heading-text">
				{#if title || infoText}
					<div class="energy-widget-title-row">
						{#if titleIcon}
							<span class="energy-widget-title-icon">
								<Icon icon={titleIcon} size="m" />
								{#if titleIconSecondary}
									<span class="energy-widget-title-icon-secondary">
										<Icon icon={titleIconSecondary} size="xs" />
									</span>
								{/if}
							</span>
						{/if}
						{#if title}
							<Text styleType="h2" class="text-600">{title}</Text>
						{/if}
					</div>
				{/if}
				{#if subtitle}
					<slot name="subtitle">
						<Text styleType="miniature" class="text-color-muted">{subtitle}</Text>
					</slot>
				{/if}
			</div>
			<div class="energy-widget-heading-actions">
				<slot name="actions" />
				{#if infoText}
					<EmInfoTooltip text={infoText} />
				{/if}
			</div>
		</div>
	{/if}
	<div class="energy-widget-body">
		<slot />
	</div>
</Container>

<style>
	.energy-widget-heading {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		gap: var(--spacing-s);
		margin-bottom: var(--spacing-m);
		min-width: 0;
		height: auto;
		flex: 0 0 auto;
	}

	.energy-widget-heading-text {
		display: flex;
		flex-direction: column;
		gap: var(--spacing-xxs);
		min-width: 0;
	}

	.energy-widget-heading-actions {
		display: inline-flex;
		align-items: center;
		gap: var(--spacing-xs);
		flex: 0 0 auto;
	}

	.energy-widget-title-row {
		display: inline-flex;
		align-items: center;
		gap: var(--spacing-xs);
		min-width: 0;
	}

	.energy-widget-title-icon {
		position: relative;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: var(--spacing-xl);
		height: var(--spacing-xl);
		flex: 0 0 auto;
		border-radius: var(--radius-pill);
		color: var(--color-white);
		background: var(--color-primary);
	}

	.energy-widget-title-icon-secondary {
		position: absolute;
		right: calc(var(--spacing-xxs) * -1);
		bottom: calc(var(--spacing-xxs) * -1);
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: var(--spacing-m);
		height: var(--spacing-m);
		border-radius: var(--radius-pill);
		color: var(--color-white);
		background: var(--color-primary);
		box-shadow: 0 0 0 var(--spacing-xxs) var(--surface-glass-fallback-bg);
	}

	.energy-widget-body {
		display: flex;
		flex-direction: column;
		flex: 1;
		justify-content: flex-start;
		align-items: stretch;
		min-width: 0;
		min-height: 0;
	}
</style>
